<template>
  <div class="leftres">
    <div>
      <div :class=" showorhide ? 'inputtop' : 'inputtops' ">
        <div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
          <Commondropdownlist ref="badsphfref" :widths="item.widths" :options="item.options" :lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
        </div>
        <div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
          <CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
        </div>
        <div style="height:10px;">
        </div>
      </div>
      <div class="TableBox" style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
        <DSPHFtable :tableData="tableData" :total="total" @CRExport="CRExport" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></DSPHFtable>
      </div>
      <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK" :src="'../assets/icon/icon-errors.png'">
        <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
      </Dialog>
    </div>
  </div>
</template>
<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../../components/commongroup.vue'
import Dialog from '../../../components/dialog.vue'
import DSPHFtable from './components/DSPHFtable.vue'
import formdata from './fromData/formdata'
import utils from '../../../common/utils'
import {
  CusRelationProviderList,
  CusRelationProviderExport,
  InventoryClassList,
  HospitalGetHospitalType
} from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    DSPHFtable,
    Dialog,
    CommonBtngroup
  },
  data() {
    return {
      tableData: [],
      total: 1,
      pageindex: 1,
      pageSize: 20,
      dialogVisibles: false,
      showorhide: true,
      formdata: [

      ],
      from: {
        CusName: "",
        InvClass: "",
        ProviderName: "",
        ProviderType: "",
        HosType: "",
        HPName: "",
        HasHPInvoice: "",
        TXCusName: '',
        ActiveTime1: "",
        ActiveTime2: "",
        CreateTime1: "",
        CreateTime2: ""
      }
    }
  },
  mounted() {
    this.formdata = JSON.parse(JSON.stringify(formdata))
    this.cusRelationProviderList()
    this.inventoryClassList()
    this.hospitalGetHospitalType()
  },
  methods: {
    // 列表
    async cusRelationProviderList() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        data,
        code
      } = await CusRelationProviderList({
        CusName: this.from.CusName,
        InvClass: this.from.InvClass,
        ProviderName: this.from.ProviderName,
        ProviderType: this.from.ProviderType,
        // HosType: this.from.HosType,
        TXCusName: this.from.TXCusName,
        HPName: this.from.HPName,
        HasHPInvoice: this.from.HasHPInvoice,
        // ActiveTime1: this.from.ActiveTime1,
        // ActiveTime2: this.from.ActiveTime2,
        CreateTime1: this.from.CreateTime1,
        CreateTime2: this.from.CreateTime2,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      if (code == 0) {
        this.total = data.Count
        if (data.data) {
          this.tableData = data.data
        }
      }
      loading.close();
    },
    // 导出
    async cusRelationProviderExport() {
      let resexprot = await CusRelationProviderExport({
        CusName: this.from.CusName,
        InvClass: this.from.InvClass,
        ProviderName: this.from.ProviderName,
        ProviderType: this.from.ProviderType,
        // HosType: this.from.HosType,
        TXCusName: this.from.TXCusName,
        HPName: this.from.HPName,
        HasHPInvoice: this.from.HasHPInvoice,
        // ActiveTime1: this.from.ActiveTime1,
        // ActiveTime2: this.from.ActiveTime2,
        CreateTime1: this.from.CreateTime1,
        CreateTime2: this.from.CreateTime2,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      if (resexprot) {
        //console.log(resexprot);
        if (resexprot.code == 999) {
          this.$message({
            type: "warning",
            message: resexprot.message
          })
        }
        let date = new Date()
        let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
        utils.downloadFile(resexprot.data, `经销商/服务商/医院备案${str}`, "xlsx")
      } else {
        // 返回json
        this.$message.warning('导出失败');
      }
    },
    CRExport() {
      this.cusRelationProviderExport()
    },
    // 产品线下拉
    async inventoryClassList() {
      let {
        code,
        data
      } = await InventoryClassList({

      })
      if (code == 0) {
        this.formdata[1].options = []
        data.data.map((item, index) => {
          let obj = {
            key: item.InvClass,
            value: item.InvClassName
          }
          this.formdata[1].options.push(obj)
        })

      }
    },
    async hospitalGetHospitalType() {
      let {
        data,
        code
      } = await HospitalGetHospitalType({
      })
      if (code == 0) {
        this.formdata[3].options = []
        data.map((item, index) => {
          let obj = {
            key: item.Name,
            value: item.Name
          }
          this.formdata[3].options.push(obj)
        })
      }
    },
    reset() {
      this.$refs.badsphfref.map((item, index) => {
        if (index == 6 || index == 7) {
          item.startTime = ''
          item.endTime = ''
        }
        item.modelvalue = ""
      })
    },
    cancel() {
      // //console.log('name')
      this.dialogVisibles = false
    },
    dialogOK() {
      // //console.log('name2')
      this.dialogVisibles = false
    },
    hide() {
      this.showorhide = false
      // //console.log("askdas", this.showorhide)

    },
    showclick() {
      this.showorhide = true
    },
    select() {
      // 处理异常（折叠搜索框）
      this.pageindex = 1
      try {
        this.from.CusName = this.$refs.badsphfref[0].modelvalue
        this.from.InvClass = this.$refs.badsphfref[1].modelvalue
        this.from.ProviderName = this.$refs.badsphfref[2].modelvalue
        // this.from.ProviderType = this.$refs.badsphfref[3].modelvalue
        // this.from.HosType = this.$refs.badsphfref[4].modelvalue
        this.from.TXCusName = this.$refs.badsphfref[3].modelvalue
        this.from.HPName = this.$refs.badsphfref[4].modelvalue
        this.from.HasHPInvoice = this.$refs.badsphfref[5].modelvalue
        // this.from.ActiveTime1 = this.$refs.badsphfref[6].startTime
        // this.from.ActiveTime2 = this.$refs.badsphfref[6].endTime
        this.from.CreateTime1 = this.$refs.badsphfref[6].startTime
        this.from.CreateTime2 = this.$refs.badsphfref[6].endTime
        this.cusRelationProviderList()
      } catch (error) {
        this.cusRelationProviderList()
      }
    },
    handleCurrentChange(pageindex) {
      this.pageindex = pageindex
      this.cusRelationProviderList()
    },
    handleSizeChange(paegSzie) {
      this.pageSize = paegSzie
      this.cusRelationProviderList()
    },
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height: 50px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  transition: all 0.3s;
  overflow: hidden;
}
.inputtops {
  width: 980px;
  height: 0px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 9px;
  padding-bottom: 64px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s;
}
.Btngroup {
  display: inline-block;
  float: right;
  margin-right: 20px;
  width: 310px;
  height: 50px;
  background-color: #ffffff;
  position: relative;
  bottom: 95px;
}
.Btngroups {
  display: inline-block;
  float: right;
  margin-top: 5px;
  margin-right: 0px;
}
</style>